import { ProfileInfo } from "@/model/system";

export class UserState {
    profile: ProfileInfo = new ProfileInfo();
}

export class RootState {
    userStore: UserState = new UserState();
}
